module.exports = __webpack_public_path__ + "static/media/Legal_Notice_ESP.af67acf7.pdf";